import { ScenarioBuilderClient } from "@/pages/scenario-builder/api/client/scenarioClient";

type SubmitScenarioParams = {
  scenarioBuilderClient: ScenarioBuilderClient;
  scenarioId: string;
};

export const submitScenarioV2 = ({ scenarioBuilderClient, scenarioId }: SubmitScenarioParams) => {
  return scenarioBuilderClient.scenarios.submitScenario({
    scenarioUuid: scenarioId,
  });
};
